import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axios";
import { notify } from "../../../util/helpers";

//TODO: Segregate the promises and api call logic into their own files and call them here.
const initialState = {
  isInitialized: false,
  firstLoad: true,
  user: null,
  loading: false, //!This is only for when no other API calls should be made while the state is changing. GLOBAL LOADING STATE.
  notification: { open: false },
  redirectTo: "",
  passwordLoading: false,
  accountExists: true,
  staffDataLoading: false,
  staffData: [],
  selectedClinic: {},
  twsCoordinatorLoading: false,
  twsCoordinatorData: [],
  selectedProvider: null,
  // verify otp call
  otpSending: false,
  otpVerifying: false,
  tempToken: null,
  authToken: null,
  userData: null,
  otpError: null,
  verifyOtpError: null,
  password:null,
  username:null
};

const resetLoadingStateLogic = (state) => {
  //* Sometimes the loading state would be stuck at true even after logout causing the Login button to be stuck at a disabled state.
  //* This reducer will be able to manually set it back to false!
  state.loading = false;
};
const resetOtpVerifyTokenLogic = (state) => {
  state.tempToken = null;
}

const resetOtpVerifyingLogic = (state) => {
  state.otpVerifying = false;
  state.verifyOtpError = null;
}

const setFirstLoadLogic = (state, { payload }) => {
  //* firstLoad state indicates that the bunch of APIs under DashboardHome's initial load have all finished.
  // The idea is to stop navigation to other pages before all required data is loaded.
  state.firstLoad = payload?.status; //? Boolean
};

const setInitializedLogic = (state) => {
  state.isInitialized = true;
};

const setUserLogic = (state, { payload }) => {
  state.user = payload;
};

const setSelectedClinicLogic = (state, { payload }) => {
  state.selectedClinic = payload;
};
const setProviderLogic = (state, { payload }) => {
  state.selectedProvider = payload;
};

export const fetchTWSCoordinatorLogic = createAsyncThunk(
  "youth/tws-coordinator",
  () => {
    return axiosInstance.get("/api/tws-coordinator/", {
      headers: {
        Authorization: `JWT ${localStorage.access}`,
        "Content-Type": "application/json",
      },
    });
  }
);

export const registerCaregiverLogic = createAsyncThunk(
  "caregiver/register",
  (payload) => {
    return axiosInstance.post(
      "/api/caregiver-custom/register-caregiver/",
      JSON.stringify(payload)
    );
  }
);

export const loginUserLogic = createAsyncThunk("user/login", (payload) => {
  const { username, password } = payload;

  return axiosInstance.post(
    "/auth/token/",
    JSON.stringify({
      username: username,
      password: password,
    })
  );
});

export const tokenRefreshLogic = createAsyncThunk(
  "token/refresh",
  (refreshToken) => {
    return axiosInstance.post(
      "/auth/token/refresh/",
      JSON.stringify({ refresh: refreshToken })
    );
  }
);

export const tokenValidationLogic = createAsyncThunk(
  "token/validate",
  (accessToken) => {
    return axiosInstance.post(
      "/auth/token/validate/",
      JSON.stringify({ token: accessToken })
    );
  }
);
// in place of login for MFA
export const sendOtpLogic = createAsyncThunk("user/sendOtp", async (payload) => {
  const { username, password } = payload;

  try {
     const response = await axiosInstance.post(
    "/auth/send-otp/",
    {
      username,
      password,
    }
  );

  return response.data;
  } catch (error) {
    console.log(error?.response?.data,'Error at the time of authentication');
    return error?.response?.data;
  }
 
});



export const verifyOtpLogic = createAsyncThunk("user/verifyOtp", async (payload) => {
  const { temp_token, otp_code } = payload;

  const response = await axiosInstance.post(
    "/auth/verify-otp/",
    {
      temp_token,
      otp_code,
    }
  );

  return response.data;
});


export const fetchMeLogic = createAsyncThunk("user/fetch", (accessToken) => {
  return axiosInstance.get("/me/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${accessToken}`,
    },
  });
});

export const changePasswordLogic = async (payload) => {
  return axiosInstance
    .post("/me/change_password/", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
    })
    .then()
    .catch();
};

export const saveProfileLogic = createAsyncThunk(
  "user/clinic-admin",
  (payload) => {
    return axiosInstance.request({
      method: "patch",
      url: `/api/clinic-admin/${payload.clinicId.toString()}/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify(payload.formData),
    });
  }
);

export const saveStaffProfileLogic = createAsyncThunk(
  "user/clinic-staff",
  (payload) => {
    return axiosInstance.request({
      method: "patch",
      url: `/api/clinic-staff/${payload.clinicId.toString()}/`,
      headers: {
        Authorization: `JWT ${localStorage.access}`,
      },
      data: JSON.stringify(payload.formData),
    });
  }
);
export const checkAccountExistsLogic = (payload) => {
  //? payload = {email:"alyengar@precisebh.com"}
  //? output = true / false based on whether or not this account exists
  return axiosInstance.post(
    "/me/check_account_exists/",
    JSON.stringify(payload)
  );
};

export const getStaffLogic = createAsyncThunk("user/get-staff", () => {
  return axiosInstance.get("/me/get_staff/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `JWT ${localStorage?.access}`,
    },
  });
});

const logoutUserLogic = (state, action) => {
  state.user = null;
  state.selectedClinic = null;
  state.selectedProvider = null;
  state.tempToken = null;
  state.username = null;
  state.password = null;
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("session_last_activity");
};

const caregiverAPICalls = {
  [registerCaregiverLogic.pending]: (state) => {
    state.loading = true;
  },
  [registerCaregiverLogic.fulfilled]: (state, { payload }) => {
    state.loading = false;
    notify("You've been registered! Try logging in!");
    window.location.replace("/login/");
  },
  [registerCaregiverLogic.pending]: (state, action) => {
    state.loading = false;
    notify("Something went wrong while linking your accounts!", "error");
  },
};

const loginAPICalls = {
  [loginUserLogic.pending]: (state) => {
    state.loading = true;
    state.user = null;
  },
  [loginUserLogic.fulfilled]: (state, { payload }) => {
    localStorage.setItem("access", payload.data.token.access);
    localStorage.setItem("refresh", payload.data.token.refresh);
    state.user = payload.data.user;
    state.loading = false;
  },
  [loginUserLogic.rejected]: (state, action) => {
    state.user = null;
    state.loading = false;
  },
};

const meAPICalls = {
  [fetchMeLogic.pending]: (state) => {
    console.log("Pending request resolution for /me/");
  },
  [fetchMeLogic.fulfilled]: (state, { payload }) => {
    console.log("Authorized user with the current access token!");
    state.user = payload.data;
  },
  [fetchMeLogic.rejected]: (state, action) => {
    console.log("Unauthorized or the API failed. Either way, you're out!");
    state.user = null; //? This should throw the user back to the login screen
  },

  //* GET STAFF DATA
  [getStaffLogic.pending]: (state) => {
    state.staffDataLoading = true;
  },
  [getStaffLogic.fulfilled]: (state, { payload }) => {
    state.staffDataLoading = false;
    state.staffData = payload.data;
  },
  [getStaffLogic.rejected]: (state, action) => {
    state.staffDataLoading = false;
  },

  //*Update profile information
  [saveProfileLogic.pending]: (state) => {
    state.loading = true;
  },
  [saveProfileLogic.fulfilled]: (state, { payload }) => {
    state.user = payload?.data;
    state.loading = false;
    notify("Profile updated successfully!");
  },
  [saveProfileLogic.rejected]: (state, action) => {
    state.loading = false;
    notify("Something went wrong!", "error");
  },

  //*Update staff profile information
  [saveStaffProfileLogic.pending]: (state) => {
    state.loading = true;
  },
  [saveStaffProfileLogic.fulfilled]: (state, { payload }) => {
    state.user = payload?.data;
    state.loading = false;
    notify("Profile updated successfully!");
  },
  [saveStaffProfileLogic.rejected]: (state, action) => {
    state.loading = false;
    notify("Something went wrong!", "error");
  },
};

const TWSAPICalls = {
  [fetchTWSCoordinatorLogic.pending]: (state) => {
    state.twsCoordinatorLoading = true;
  },
  [fetchTWSCoordinatorLogic.fulfilled]: (state, { payload }) => {
    state.twsCoordinatorLoading = false;
    state.twsCoordinatorData = payload.data;
  },
  [fetchTWSCoordinatorLogic.rejected]: (state, action) => {
    state.twsCoordinatorLoading = false;
  },
};

const tokenAPICalls = {
  //*TOKEN REFRESH PROMISES
  [tokenRefreshLogic.pending]: (state) => {
    if (!localStorage.getItem(refresh)) {
      console.log("No refresh token for the user!");
      //TODO: Do something with this information
    }
  },
  [tokenRefreshLogic.fulfilled]: (state, { payload }) => {
    localStorage.removeItem("access");
    console.log("Refresh token payload", payload);
    localStorage.setItem("access", payload.data?.access);
  },
  [tokenRefreshLogic.rejected]: (state, action) => {
    console.log("Refresh token has expired for this user!");
    //TODO: Do something with this information
  },

  //*TOKEN VALIDATION PROMISES
  [tokenValidationLogic.pending]: (state) => {
    if (!localStorage.getItem("access")) {
      console.log("No access token for the user!");
      //TODO: Do something with this information
      return false;
    }
  },
  [tokenValidationLogic.fulfilled]: (state, { payload }) => {
    console.log("access token payload", payload);
    return true;
  },
  [tokenValidationLogic.rejected]: (state, action) => {
    return false;
  },
};

const sendOtpCalls={
  [sendOtpLogic.pending]: (state,action) => {
    state.otpSending = true;
    state.otpError = null;
    const { username, password } = action.meta.arg;
    state.username = username;
    state.password = password;
  },
  [sendOtpLogic.fulfilled]: (state, { payload }) => {
    state.otpSending = false;
    state.tempToken = payload.temp_token; // assuming API returns this
  },
  [sendOtpLogic.rejected]: (state, action) => {
    state.otpSending = false;
    state.otpError = action.error?.message || "Failed to send OTP";
  },
}

const verifyOtpCall = {
  [verifyOtpLogic.pending]: (state) => {
    state.otpVerifying = true;
    state.verifyOtpError = null;
    state.user = null;
  },
  [verifyOtpLogic.fulfilled]: (state, { payload }) => {
    console.log(payload,'payload')
    localStorage.setItem("access", payload.token.access);
    localStorage.setItem("refresh", payload.token.refresh);
    localStorage.setItem("session_last_activity", Date.now().toString());
    state.user = payload.user;
    state.tempToken = null;
    state.password = null;
    state.username = null;
    state.otpVerifying = false;
  },
  [verifyOtpLogic.rejected]: (state, action) => {
    state.otpVerifying = false;
    state.verifyOtpError = "Invalid or Expired OTP";
    state.user = null;
  },
}
const appSlice = createSlice({
  name: "app",
  initialState,
  extraReducers: {
    ...loginAPICalls,
    ...tokenAPICalls,
    ...meAPICalls,
    ...caregiverAPICalls,
    ...TWSAPICalls,
    ...sendOtpCalls,
    ...verifyOtpCall
  },
  reducers: {
    resetLoadingState: resetLoadingStateLogic,
    setFirstLoad: setFirstLoadLogic,
    setInitialized: setInitializedLogic,
    registerCaregiver: registerCaregiverLogic,
    loginUser: loginUserLogic,
    logoutUser: logoutUserLogic,
    token: tokenRefreshLogic,
    setUser: setUserLogic,
    fetchMe: fetchMeLogic,
    setSelectedClinic: setSelectedClinicLogic,
    setProvider: setProviderLogic,
    saveProfile: saveProfileLogic,
    saveSaffProfile:saveStaffProfileLogic,
    fetchTWSCoordinator: fetchTWSCoordinatorLogic,
    sendOtp:sendOtpLogic,
    verifyOtp:verifyOtpLogic,
    resetOtpVerifying:resetOtpVerifyingLogic,
    resetOtpVerifyToken:resetOtpVerifyTokenLogic
  },
});

export const {
  resetLoadingState,
  setFirstLoad,
  setInitialized,
  loginUser,
  registerCaregiver,
  setUser,
  logoutUser,
  token,
  fetchMe,
  setSelectedClinic,
  setProvider,
  saveProfile,
  fetchTWSCoordinator,
  otpSending,
  otpVerifying,
  tempToken,
  authToken,
  userData,
  otpError,
  verifyOtpError,
  password,
  username,
  resetOtpVerifyToken,
  resetOtpVerifying
} = appSlice.actions;
export default appSlice.reducer;